import tinycolor from "tinycolor2";
import imgs from "../imgs";
var colors = {
    main: "#ffff",
    accent1: "#40916C",
    accent2: "#9BA5D5",
    accent3: "#2F3E46",
    accent4: "#D1FAFF",
    accent5: "#3CCDCB",
    accent6: "#2EB2A3",
    accent7: "#A1B7C2",
    accent8: "#EAF8F0",
    accent9: "#95D5B2",
    lightText: "#364958",
    lightHeaderText: "#C3DAD5",
    lightTextValue: "#0B840B",
    lightBg: "#EFF3F0",
    lightBg2: "#EBEDF8",
    lightBg3: "#FCFDFD",
    lightBg4: "#ebf9fb",
    textMain: "#505256",
    titleScHeading: "#092927",
    textAlt1: "#3E4248",
    textAlt2: "#1D7268",
    textAlt3: "#435864",
    textAlt4: "#898A92",
    textAlt5: "#171718",
    white: "#fff",
    grey: "#D8D8D8",
    lightGrey: "#FBFCFC",
    black: "#092927",
    success: "#A0E1DA",
    error: "#ef476f",
    warning: "#ffd166",
    notification: "#F25162",
    anchorItemBefore: "#7CB8D5",
    anchorItemAfter: "#2F3E46",
    chenin: "#7CB8D5",
    rioGrande: "#2F3E46",
    elm: "#1D7268",
    praisWhite: "#C2DAD5",
    geyser: "#C6DADD",
    turquoise: "#3CCDCB",
    ziggurat: "#C1DBDE",
    polar: "#EEF7FB",
    jungleMist: "#B0CED2",
    waterLeaft: "#91E3D9",
    mystic: "#E2EDEA",
    lightGreen: "#82C182",
    blueWater: "#CCE7CC",
    greenWater: "#EBF2EB",
    blueGray: "#ECF3F7",
    ghostGray: "#FAFCFF",
};
var fontWeight = {
    lightText: "bold",
};
var ffMain = "Poppins";
var ffAlt = "Poppins";
var lightTheme = {
    name: "light",
    gwThemed: {
        sectionHeading: {
            color: colors.titleScHeading,
        },
        footer: {
            bg: colors.white,
            color: colors.textMain,
            borderColor: tinycolor(colors.accent3).setAlpha(0.15).toString(),
        },
        header: {
            bg: colors.main,
            bgMobile: colors.white,
            color: colors.lightHeaderText,
            colorMobile: colors.accent3,
            borderColor: tinycolor(colors.white).setAlpha(0.1).toString(),
        },
        logo: imgs.greenLogo,
        logoStacked: imgs.greenLogoStacked,
        leftNav: {
            color: colors.accent3,
            comingSoon: colors.textAlt4,
            bg: colors.lightBg,
            borderColor: colors.white,
            selectedMarkerColor: colors.white,
            selectedBg: colors.accent3,
            subItems: {
                bg: tinycolor(colors.lightBg).lighten(3).toString(),
                hoverBg: colors.lightBg,
            },
        },
        topBar: {
            bg: colors.main,
            color: colors.lightText,
            valueColor: colors.lightTextValue,
            borderColor: colors.white,
            fontWeight: fontWeight.lightText,
        },
        middleBar: {
            bg: colors.lightGrey,
            color: colors.lightText,
            valueColor: colors.lightTextValue,
            borderColor: colors.grey,
            fontWeight: fontWeight.lightText,
            chevron: colors.accent1,
        },
        generalContent: {
            bg: colors.white,
            altBg: colors.lightBg3,
            inputSelect: {
                border: {
                    color: colors.accent7,
                },
            },
            text: {
                main: {
                    color: colors.textMain,
                },
                alt: {
                    color: colors.textAlt1,
                },
                light: {
                    color: colors.lightText,
                },
                emphasis: {
                    color: colors.accent3,
                },
                darker: {
                    color: colors.black,
                },
                danger: {
                    color: colors.error,
                },
                link: {
                    color: colors.accent1,
                    hoverColor: tinycolor(colors.accent1).lighten(5).toString(),
                },
                title: {
                    color: colors.main,
                },
            },
            borderRadius: "3px",
            table: {
                borderColor: colors.accent2,
            },
        },
        separator: {
            color: colors.lightBg2,
        },
        alerts: {
            normal: {
                bg: tinycolor(colors.lightGreen).lighten(30).toString(),
                color: colors.textMain,
            },
            success: {
                bg: tinycolor(colors.blueWater).lighten(0).toString(),
                color: colors.textMain,
            },
            error: {
                bg: tinycolor(colors.error).lighten(26).toString(),
                color: colors.textMain,
            },
            warning: {
                bg: tinycolor(colors.warning).lighten(18).toString(),
                color: colors.textMain,
            },
        },
        badges: {
            normal: { bg: colors.lightBg, color: colors.textAlt2 },
        },
        accordion: {
            color: colors.accent1,
            lightHoverColor: colors.lightBg2,
            borderColor: colors.accent2,
            bg: colors.white,
            shadow: tinycolor(colors.textAlt2).setAlpha(0.13).toString(),
        },
        loader: {
            color: colors.lightBg2,
        },
        buttons: {
            main: {
                bg: colors.accent1,
                hoverBg: tinycolor(colors.accent1).lighten(5).toString(),
                color: colors.white,
                hoverColor: colors.white,
                lightHoverColor: colors.lightBg2,
            },
            disabled: {
                bg: colors.lightText,
                color: colors.white,
                hoverBg: colors.lightText,
                hoverColor: colors.white,
            },
            selected: {
                bg: colors.lightBg2,
            },
            alt: {
                bg: colors.accent3,
                hoverBg: tinycolor(colors.accent3).lighten(5).toString(),
                color: colors.white,
                hoverColor: colors.white,
            },
            altSelected: {
                bg: colors.lightBg,
            },
            danger: {
                bg: colors.error,
                hoverBg: tinycolor(colors.error).lighten(5).toString(),
                color: colors.white,
                hoverColor: colors.white,
            },
        },
        inputs: {
            main: {
                color: colors.accent1,
                borderColor: colors.accent2,
                bg: colors.white,
                focusBg: tinycolor(colors.lightBg2).lighten(0).toString(),
            },
            alt: {
                color: colors.accent3,
                borderColor: colors.accent3,
                focusBg: colors.lightBg3,
                bg: colors.white,
            },
            disabled: {
                bg: tinycolor(colors.lightBg).lighten(0).toString(),
                focusBg: tinycolor(colors.lightBg).lighten(0).toString(),
                borderColor: colors.lightText,
                color: colors.textMain,
            },
        },
        progressBar: {
            background: colors.lightBg,
            color: colors.accent5,
        },
        pill: {
            text: colors.textAlt1,
            successText: colors.white,
            successBg: colors.accent1,
            secondaryText: colors.white,
            secondaryBg: colors.textAlt4,
            warningText: colors.white,
            warningBg: colors.warning,
        },
        startDesign: {
            title: tinycolor(colors.textAlt2).darken(13).toString(),
            counter: {
                color: colors.textAlt3,
                accent: colors.black,
            },
            questions: {
                title: tinycolor(colors.textAlt2).darken(13).toString(),
                bulletPoints: colors.accent3,
                link: {
                    color: colors.accent1,
                },
            },
        },
        karmTool: {
            questionnaire: {
                bg: colors.white,
                section: {
                    borderColor: colors.lightBg2,
                },
                question: {
                    infoIcon: {
                        bg: colors.accent1,
                        color: colors.white,
                    },
                    infoTooltip: {
                        borderColor: colors.lightBg2,
                        bg: colors.white,
                        color: colors.textMain,
                        resourcesColor: tinycolor(colors.accent2).darken(10).toString(),
                    },
                    warnMessage: {
                        color: colors.accent6,
                        icon: {
                            background: colors.accent6,
                        },
                    },
                },
            },
            diagram: {
                bg: colors.white,
                tabs: {
                    color: colors.textAlt3,
                    selectedColor: colors.textAlt2,
                    selectedIndicatorColor: colors.accent1,
                    bg: colors.lightBg,
                    borderColor: colors.lightBg2,
                },
                legend: {
                    color: colors.textAlt2,
                },
                farmDetailsLegendItem: {
                    titleColor: colors.textAlt3,
                },
                array: {
                    colors: {
                        chenin: colors.chenin,
                        rioGrande: colors.rioGrande,
                        elm: colors.elm,
                        praisWhite: colors.praisWhite,
                        geyser: colors.geyser,
                        turquoise: colors.turquoise,
                        ziggurat: colors.ziggurat,
                        polar: colors.polar,
                        jungleMist: colors.jungleMist,
                        waterLeaft: colors.waterLeaft,
                        mystic: colors.mystic,
                    },
                    flotationBuoy: colors.turquoise,
                },
            },
            anchorLine: {
                buoyItem: {
                    before: colors.anchorItemBefore,
                    after: colors.anchorItemAfter,
                },
            },
        },
        admin: {
            codeEditor: {
                background: colors.lightHeaderText,
                valid: colors.success,
                invalid: colors.error,
            },
        },
    },
    colors: colors,
    responsive: {
        mobile_sm: "320px",
        mobile_md: "480px",
        mobile_lg: "620px",
        tablet_md: "720px",
        tablet_lg: "940px",
        desktop_sm: "1100px",
        desktop_md: "1200px",
        desktop_lg: "1350px",
        desktop_xlg: "1500px",
    },
    measures: {
        mobileBleed: "16px",
        tabletBleed: "20px",
        desktopBleed: "25px",
        desktopMaxWidth: "1440px",
        navDesktopWidth: "240px",
        desktopCardWidth: "320px",
        karmNavDesktopWidth: "136px",
        karmDiagramDesktopWidth: "630px",
    },
    z: {
        tooltip: 6000,
        modal: 5000,
        nav: 2000,
        stickyheader: 1000,
        content: 500,
    },
    fontFamilies: {
        ffMain: "\"" + ffMain + "\", sans-serif",
        ffAlt: "\"" + ffAlt + "\", sans-serif",
    },
    fontfaceObserverArray: [ffMain, ffAlt],
    transitions: {
        normal: "150ms",
        notification: "5000ms",
    },
    borders: {
        radius: "3px",
    },
};
export default lightTheme;
//# sourceMappingURL=gw2021.js.map